import { sortBy } from '@agilepoint/utils-array';
import { useTranslate } from '@agilepoint/wat-react';
import { ListView, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { IllustrationMessage } from 'common';
import { INotificationDetail } from 'modules/core/types';
import React from 'react';
import styled from 'styled-components';
import { NotificationListItem } from './notification-list-item';

interface INotificationContentProps {
    showHideCallout: (value: boolean) => void;
    notificationDetails: INotificationDetail[];
}

const CalloutTitle = styled(Typography.H5)`
    text-align: center;
    padding: 12px;
    border-bottom: 1px solid #ccc;
`;

const StyledListView = styled(ListView)`
    border-width: 0px !important;
    .ap-listView-itemContentWrapper {
        border: none;
        border-bottom: 1px solid #ccc; 
    }
`;

const StyledStackPanel = styled(StackPanel)`
    /* min-height: 200px; */
`;

const StyledIllustrationMessage = styled(IllustrationMessage)`
    /* padding-bottom: 50px; */
    /* border-top: 1px solid #ccc; */
    .ap-illustration-wrapper {
        margin: -10px auto;
    }
`;

export function NotificationContent(props: INotificationContentProps) {
    const { notificationDetails, showHideCallout } = props;
    const sortedItems = sortBy(notificationDetails, (i) => i.lastModifiedOn, true);
    const translate = useTranslate();

    const renderNotiicationDetails = React.useCallback((item: INotificationDetail) => (
        <NotificationListItem notificationDetail={item} showHideCallout={showHideCallout} />
    ), [showHideCallout]);

    const renderTitle = React.useCallback(() => (
        <CalloutTitle>{translate('modules.userActions.notifications.title')}</CalloutTitle>
    ), [translate]);

    return (
        <>
            {renderTitle()}
            <StyledStackPanel width='300px' height='300px' justifyContent='center' alignment='center'>
                {(sortedItems.length > 0) ?
                    <StyledListView itemWidth={388} itemHeight={100} items={sortedItems} onRenderItemContent={renderNotiicationDetails} />
                    : <StyledIllustrationMessage type='ap-empty-3' displayMessage="No Notifications" height='calc(100% - 1px)' />}
            </StyledStackPanel>
        </>
    );
}
